import { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { api } from "../lib/api";
import { useAuth } from "../context/AuthContext";

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
export default function AuthCallback() {
    const navigate = useNavigate();
    const { setUser } = useAuth();
    const ran = useRef(false);

    useEffect(() => {
        if (ran.current) return;
        ran.current = true;
        const hash = window.location.hash || "";
        const match = hash.match(/session_id=([^&]+)/);
        const sessionId = match ? decodeURIComponent(match[1]) : null;
        if (!sessionId) {
            navigate("/login", { replace: true });
            return;
        }
        (async () => {
            try {
                const { data } = await api.post(
                    "/auth/google/session",
                    { role: "respondent" },
                    { headers: { "X-Session-ID": sessionId } }
                );
                setUser(data.user);
                window.history.replaceState({}, document.title, "/");
                const target =
                    data.user.role === "admin"
                        ? "/admin"
                        : data.user.role === "advertiser"
                            ? "/advertiser"
                            : "/respondent";
                navigate(target, { replace: true });
            } catch {
                navigate("/login?error=google", { replace: true });
            }
        })();
    }, [navigate, setUser]);

    return (
        <div className="min-h-screen flex items-center justify-center bg-paper">
            <div className="font-mono text-xs text-ink-600">SIGNING YOU IN VIA GOOGLE…</div>
        </div>
    );
}
